<div class="relative w-full top-0 h-[4.6rem] bg-gray-900"></div>

<div [ngClass]="activeLang === 'AR' ? 'arabic' : 'english'">
  <div class="flex items-center justify-center mt-10 mb-14">
    <h1
      class="text-center inline-block text-3xl border border-black px-5 py-1 rounded-full"
    >
      {{ "equipmentCategories" | transloco }}
    </h1>
  </div>

  <!-- حالة الخطأ -->
  <div *ngIf="errorMsg" class="w-full flex items-center justify-center py-16">
    <div class="text-red-600">
      {{
        "loadError" | transloco : { default: "Failed to load categories." }
      }}
      ({{ errorMsg }})
    </div>
  </div>

  <!-- تحميل + محتوى -->
  <ng-container *ngIf="!errorMsg">
    <!-- لو البيانات وصلت -->
    <ng-container *ngIf="equipment$ | async as equipment; else loadingTpl">
      <div
        class="px-5 lg:px-10 xl:px-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-5 lg:gap-10 xl:gap-14"
      >
        <div
          class="shadow-md rounded-lg h-full bg-[#dedede17]"
          *ngFor="let item of equipment; trackBy: trackById"
        >
          <a [routerLink]="['/', activeLang, 'machines', item._id]">
            <img
              class="min-h-[270px] mx-auto"
              *ngIf="item.image?.url !== 'none'"
              loading="lazy"
              [src]="item.image?.url"
              width="80%"
              [alt]="item.altText || item.title?.[activeLang]"
            />
            <div class="p-2">
              <h2 class="font-semibold text-center mt-2 text-[#E60027]">
                {{ item.title[activeLang] }}
              </h2>
            </div>
          </a>
        </div>
      </div>

      <!-- حالة لا يوجد بيانات -->
      <div
        class="w-full flex items-center justify-center py-20"
        *ngIf="equipment.length === 0"
      >
        <div class="text-gray-600">
          {{ "noResults" | transloco : { default: "No categories found." } }}
        </div>
      </div>
    </ng-container>

    <!-- سبينر التحميل -->
    <ng-template #loadingTpl>
      <div class="w-full flex items-center justify-center py-24">
        <div class="inline-flex items-center gap-3">
          <span
            class="w-6 h-6 rounded-full border-2 border-gray-300 border-t-transparent animate-spin"
          ></span>
          <span class="text-gray-600">{{
            "loading" | transloco : { default: "Loading..." }
          }}</span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>

<div class="my-60"></div>
